module.exports = __webpack_public_path__ + "static/fonts/Gilroy-ExtraBoldItalic-10.e077182.otf";


//////////////////
// WEBPACK FOOTER
// ./src/layout/pages/home/my-workbench/Gilroy-ExtraBoldItalic-10.otf
// module id = 5vou
// module chunks = 7